module.exports = __webpack_public_path__ + "img/service_wechat_3.9def821b.jpg";